export class InvestorFeatureCodesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCodes() {
    return this.#http.get('/api/investor-feature-codes');
  }

  async createCode(body) {
    return this.#http.post('/api/investor-feature-codes', body);
  }

  async editCode({ id, ...body }) {
    return this.#http.put(`/api/investor-feature-codes/${id}`, body);
  }

  async deleteCode({ id }) {
    return this.#http.delete(`/api/investor-feature-codes/${id}`);
  }
}
